import { render, staticRenderFns } from "./BasicDataTagger.vue?vue&type=template&id=72a49786&scoped=true"
import script from "./BasicDataTagger.vue?vue&type=script&lang=js"
export * from "./BasicDataTagger.vue?vue&type=script&lang=js"
import style0 from "./BasicDataTagger.vue?vue&type=style&index=0&id=72a49786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a49786",
  null
  
)

export default component.exports